import { useEffect, useState } from "react";
import EmptyStateTable from "../../../../components/emptyState/emptyStateTabel";
import SpinnerTable from "../../../../components/spinner/spinnerTable";
import { Link } from "react-router-dom";
import ModalEditSelectType2 from "../../../../components/modal/modalEditSelectType2";
import { detailTrainingDeleteParticipant, detailTrainingEditPeserta } from "../../../../config/apiSPA";
import ModalInfo from "../../../../components/modal/modalInfo";
import ModalConfirm from "../../../../components/modal/modalConfirm";
const editModalInitialState = {
  show: false,
  id: null,
  selected: null,
  initialText: "",
  selector: "",
};
const editModalOptions = {
  manpower: {
    title: "Edit Participant",
    text: "Select a training participant from the list and add a remark, if any.",
  },
};

const infoModalInitialState = {
  show: false,
  title: "",
  text: "",
  theme: "",
};
const confirmModalInitalState = {
  show: false,
  title: "",
  text: "",
  theme: "",
  id: null,
  selector: "",
};
function TrainingParticipantTable({ participantData, isLoading, onUpdate = () => {} }) {
  const [editModalState, setEditModalState] = useState(editModalInitialState);
  const [infoModalState, setInfoModalState] = useState(infoModalInitialState);
  const [confirmModalState, setConfirmModalState] = useState(confirmModalInitalState);
  const handleClickEditPart = (participant) => {
    const { id, remark, manpowerData } = participant;
    const manpowerId = manpowerData.id;
    setEditModalState({
      show: true,
      id,
      selected: manpowerId,
      initialText: remark ?? "",
      selector: "manpower",
    });
  };
  const handleSubmitEditModal = async ({ id, val, textVal }, selector) => {
    setEditModalState(editModalInitialState);
    try {
      const payload = { participantId: id, manpowerId: val, remark: textVal };
      const res = await detailTrainingEditPeserta(payload);
      onUpdate(res.data);
    } catch (error) {
      setInfoModalState({ show: true, title: "Error", text: `Failed to edit : ${error.message}`, theme: "danger" });
    }
  };
  const handleClickDeleteParticipant = (participant) => {
    setConfirmModalState({
      show: true,
      title: "Warning !!",
      text: `Are you sure want to delete participant:${participant.manpowerData?.nama ?? " Jumadi"}\n Semua nilai yang sudah terimput pada participant ini juga akan TERHAPUS`,
      theme: "danger",
      id: participant.id,
      selector: "participant",
    });
  };
  const handleClickDelete = async (val, selector) => {
    setConfirmModalState(confirmModalInitalState);
    try {
      const res = await detailTrainingDeleteParticipant(val);
      onUpdate(res.data);
    } catch (error) {
      setInfoModalState({ show: true, title: "Error", text: `Failed to delete : ${error.message}`, theme: "danger" });
    }
  };
  return (
    <>
      <div className="table-responsive">
        <table className="table table-hover text-nowrap">
          <thead>
            <tr>
              <th className="border-top-0 pt-0 pb-2">No.</th>
              <th className="border-top-0 pt-0 pb-2">Name</th>
              <th className="border-top-0 pt-0 pb-2">Company</th>
              <th className="border-top-0 pt-0 pb-2">Position</th>
              <th className="border-top-0 pt-0 pb-2">Remark</th>
              <th className="border-top-0 pt-0 pb-2"></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <SpinnerTable colSpan={6} />
            ) : participantData.length > 0 ? (
              participantData.map((participant, index) => (
                <tr key={participant.id}>
                  <td className="align-middle">{index + 1}</td>
                  <td className="align-middle">
                    <Link to={"/manpower/detail/" + participant.manpowerData.id}>{participant.manpowerData.nama}</Link>
                  </td>
                  <td className="align-middle">{participant.manpowerData.company.name}</td>
                  <td className="align-middle">{participant.manpowerData.jabatanFn}</td>
                  <td className="align-middle">{participant.remark}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <a href="#/" onClick={() => handleClickEditPart(participant)} className="btn btn-outline-default btn-sm" title="Click to Edit">
                        <i className="fas fa-edit text-theme"></i>
                      </a>
                      <a href="#/" onClick={() => handleClickDeleteParticipant(participant)} className="btn btn-outline-default btn-sm">
                        <i className="fas fa-trash-alt text-danger"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <EmptyStateTable colSpan={6} />
            )}
          </tbody>
        </table>
      </div>
      <ModalEditSelectType2
        selector={editModalState.selector}
        id={editModalState.id}
        selected={editModalState.selected}
        initialText={editModalState.initialText}
        show={editModalState.show}
        options={editModalOptions[editModalState.selector]}
        onHide={() => setEditModalState(editModalInitialState)}
        submitClick={(e) => handleSubmitEditModal(e, editModalState.selector)}
      />
      <ModalInfo
        show={infoModalState.show}
        title={infoModalState.title}
        text={infoModalState.text}
        theme={infoModalState.theme}
        onHide={() => setInfoModalState(infoModalInitialState)}
        clicked={() => setInfoModalState(infoModalInitialState)}
      />
      <ModalConfirm
        onHide={() => setConfirmModalState(confirmModalInitalState)}
        clicked={(e) => handleClickDelete(e, confirmModalState.selector)}
        show={confirmModalState.show}
        title={confirmModalState.title}
        text={confirmModalState.text}
        theme={confirmModalState.theme}
        id={confirmModalState.id}
      />
    </>
  );
}

export default TrainingParticipantTable;
